<!-- The exported code uses Tailwind CSS. Install Tailwind CSS in your dev environment to ensure all styles work. -->
<template>
  <div>
    <!-- 底部联系区域 -->
    <!-- py-20 改为 py-10  -->
    <section id="contact" class="py-10 bg-black text-white">
      <div class="container mx-auto px-6">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-16">
          <div>
            <!-- <h2 class="flex text-3xl font-bold mb-6">
              联系我们
              {{$t('company.contact_us')}}
            </h2>
            <p class="flex mb-8">
              无论您有任何问题或建议，都欢迎随时与我们联系。我们的团队将竭诚为您服务。
              {{$t('company.contact_us_desp')}}
            </p> -->
            <div class="mb-6">
              <h3 class="flex text-xl font-semibold mb-4">
                <!-- 联系方式 -->
                {{ $t("company.contact_information") }}
              </h3>
              <div class="flex items-center mb-3">
                <i class="fas fa-map-marker-alt w-6"></i>
                <span class="ml-3">待完善</span>
              </div>
              <div class="flex items-center mb-3">
                <i class="fas fa-phone w-6"></i>
                <span class="ml-3">待完善</span>
              </div>
              <div class="flex items-center mb-3">
                <i class="fas fa-envelope w-6"></i>
                <span class="ml-3">bikes@bjqteam.com</span>
              </div>
            </div>
            <div>
              <h3 class="flex text-xl font-semibold mb-4">
                <!-- 关注我们 -->
                {{ $t("company.contact_follow_us") }}
              </h3>
              <div class="flex space-x-4">
                <!-- <a
                  href="#"
                  class="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 cursor-pointer"
                >
                  <i class="fab fa-weixin text-xl"></i>
                </a> -->

                <!-- 微信公众号图标 -->
                <div class="relative group">
                  <!-- 图标 -->
                  <button
                    class="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 cursor-pointer"
                  >
                    <i class="fab fa-weixin text-xl"></i>
                  </button>
                  <!-- 箭头指示 -->
                  <div
                    class="absolute bottom-full left-1/2 -translate-x-1/2 opacity-0 invisible group-hover:opacity-100 group-hover:visible z-20"
                  >
                    <i class="fa-solid fa-caret-down"></i>
                  </div>

                  <!-- 二维码容器 (默认隐藏) -->
                  <div
                    class="absolute bottom-full mb-4 opacity-0 invisible group-hover:opacity-100 group-hover:visible qrcode-transition transform group-hover:translate-y-0 translate-y-2 z-10"
                  >
                    <div
                      class="relative bg-white p-3 rounded-lg shadow-xl border border-gray-200 w-48 max-h-screen"
                    >
                      <!-- 二维码图片 (使用占位图) -->
                      <img
                        :src="require('@/assets/ncoreimg/wxQRcode.jpg')"
                        alt="公众号二维码"
                        class="w-full h-auto rounded"
                      />
                      <p class="text-xs text-center text-gray-600 mt-2">
                        扫码关注公众号
                      </p>
                    </div>
                  </div>
                </div>
                <a
                  href="#"
                  class="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 cursor-pointer"
                >
                  <i class="fab fa-weibo text-xl"></i>
                </a>
                <!-- <a
                  href="#"
                  class="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 cursor-pointer"
                >
                  <i class="fab fa-instagram text-xl"></i>
                </a> -->
                <a
                  href="#"
                  class="w-10 h-10 bg-white bg-opacity-20 rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-300 cursor-pointer"
                >
                  <i class="fab fa-tiktok text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div
            class="font-bebas tracking-wider flex items-center justify-self-center"
          >
            <img
              src="../../assets/logo.png"
              alt="Logo"
              class="mr-1"
              :style="{
                width: 'auto',
                height: '80px',
                transform: 'translateY(-3px)',
              }"
            />
            <span class="text-3xl md:text-5xl font-bold"
              >{{ $t("company.name") }}
            </span>
          </div>

          <!-- <div>
            <h3 class="text-xl font-semibold mb-6">发送消息</h3>
            <form @submit.prevent="submitForm" class="space-y-4">
              <div>
                <label for="name" class="block mb-2">姓名</label>
                <input
                  type="text"
                  id="name"
                  v-model="contactForm.name"
                  class="w-full px-4 py-2 rounded-lg border-none text-gray-800 focus:ring-2 focus:ring-blue-500 outline-none"
                  required
                />
              </div>
              <div>
                <label for="email" class="block mb-2">邮箱</label>
                <input
                  type="email"
                  id="email"
                  v-model="contactForm.email"
                  class="w-full px-4 py-2 rounded-lg border-none text-gray-800 focus:ring-2 focus:ring-blue-500 outline-none"
                  required
                />
              </div>
              <div>
                <label for="message" class="block mb-2">留言</label>
                <textarea
                  id="message"
                  v-model="contactForm.message"
                  rows="4"
                  class="w-full px-4 py-2 rounded-lg border-none text-gray-800 focus:ring-2 focus:ring-blue-500 outline-none"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                class="bg-white text-blue-900 px-6 py-3 rounded-lg font-medium hover:bg-blue-100 transition-all duration-300 cursor-pointer !rounded-button whitespace-nowrap"
              >
                发送消息
              </button>
            </form>
          </div> -->
        </div>
      </div>
    </section>
    <!-- py-20 改为 py-10  -->
    <section id="contact" class="py-10 bg-black text-white">
      <div class="container mx-auto px-6">
        <div class="grid grid-cols-1 md:grid-cols-4 gap-16">
          <div>
            <div class="mb-6">
              <h3 class="flex text-xl font-semibold mb-4">关于我们</h3>
              <!-- <div class="flex items-center mb-3">
                <span class="">文化和价值观</span>
              </div>
              <div class="flex items-center mb-3">
                <span class="">里程碑</span>
              </div>
              <div class="flex items-center mb-3">
                <span class="">领导团队</span>
              </div>
              <div class="flex items-center mb-3">
                <span class="">我们的业务</span>
              </div> -->
              <router-link
                to="/cultureAndValues"
                class="flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              >
                <!-- 文化和价值观 -->
                {{ $t("header.culture_and_values") }}
              </router-link>
              <router-link
                :to="{ path: '/cultureAndValues', hash: '#milestone' }"
                class="flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              >
                <!-- 里程碑 -->
                {{ $t("header.milestone") }}
              </router-link>
              <router-link
                :to="{ path: '/cultureAndValues', hash: '#leadershipTeam' }"
                class="flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              >
                <!-- 领导团队 -->
                {{ $t("header.leadership_team") }}
              </router-link>
              <router-link
                to="/ourBusiness"
                class="flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              >
                <!-- 我们的业务 -->
                {{ $t("header.our_business") }}
              </router-link>
            </div>
          </div>
          <div>
            <div class="mb-6">
              <h3 class="flex text-xl font-semibold mb-4">服务资源</h3>
              <!-- <div class="flex items-center mb-3">
                <span class="">经销商查询</span>
              </div> -->
              <!-- <div class="flex items-center mb-3">
                <span class="">联系我们</span>
              </div> -->
              <router-link
                to="/manualsGuide"
                class="flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              >
                <span class="">手册和指南</span>
              </router-link>
              <router-link
                to="/faq"
                class="flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              >
                常见问题
              </router-link>
              <router-link
                to="/securityCheck"
                class="flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              >
                防伪查询
              </router-link>
            </div>
          </div>
          <div>
            <div class="mb-6">
              <h3 class="flex text-xl font-semibold mb-4">法律信息</h3>
              <!-- <div class="flex items-center mb-3">
                <span class="">服务协议</span>
              </div> -->
              <router-link
                to="/privacyPolicy"
                class="flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              >
                隐私政策
              </router-link>
              <!-- <div class="flex items-center mb-3">
                <span class="">知识产权</span>
              </div> -->
              <router-link
                to="/disclaimer"
                class="flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              >
                法律声明
              </router-link>
            </div>
          </div>
          <div>
            <div class="mb-6">
              <h3 class="flex text-xl font-semibold mb-4">联系我们</h3>

              <div class="flex items-center mb-3">
                <span class="">联系我们</span>
              </div>
              <!-- <router-link
                to="/contactUs"
                class="flex py-1 text-white transition-colors duration-300 relative inline-block cursor-pointer hover:underline underline-offset-[5px]"
              >
                联系我们
              </router-link> -->

              <!-- <div class="flex items-center mb-3">
                <span class="">常见问题</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 页脚 -->
    <footer class="bg-black text-white py-8">
      <div class="container mx-auto px-6">
        <!-- <div class="flex flex-col md:flex-row justify-between items-center"> -->
        <div class="flex flex-col justify-between items-center">
          <div class="mb-4 md:mb-0">
            <p class="text-sm text-gray-400">
              ICP备案/许可证号：
              <a
                href="https://beian.miit.gov.cn"
                class="no-underline hover:underline hover:text-blue-800"
                >浙ICP备2025176188号-1</a
              >
            </p>
            <p>
              Copyright &copy; 2025 The North Cycling Team. All Rights Reserved.
              北境骑团 bjqteam.com 版权所有
            </p>
          </div>
          <!-- <div class="flex space-x-4">
            <i class="fab fa-cc-visa text-2xl text-gray-400"></i>
            <i class="fab fa-cc-mastercard text-2xl text-gray-400"></i>
            <i class="fab fa-cc-paypal text-2xl text-gray-400"></i>
            <i class="fab fa-alipay text-2xl text-gray-400"></i>
            <i class="fab fa-weixin text-2xl text-gray-400"></i>
          </div> -->
        </div>
      </div>
    </footer>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";

// 联系表单
const contactForm = ref({
  name: "",
  email: "",
  message: "",
});
const submitForm = () => {
  alert("感谢您的留言！我们会尽快回复您。");
  contactForm.value = {
    name: "",
    email: "",
    message: "",
  };
};
onMounted(() => {});
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}
/* 二维码过度效果 */
.qrcode-transition {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
</style>
